// import React, { useState } from "react";
// import {
//   Box,
//   Container,
//   Typography,
//   Card,
//   CardContent,
//   Grid,
//   Chip,
//   TextField,
//   Button,
//   InputAdornment,
//   Snackbar,
//   Alert,
//   alpha,
// } from "@mui/material";
// import BusinessIcon from "@mui/icons-material/Business";
// import PhoneIcon from "@mui/icons-material/Phone";
// import EmailIcon from "@mui/icons-material/Email";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import SendIcon from "@mui/icons-material/Send";

// // Using the exact colors from your provided example
// const colors = {
//   darkGreen: "#1B5E20",
//   mediumGreen: "#2E7D32",
//   lightGreen: "#4CAF50",
//   paleGreen: "#E8F5E9",
//   darkOrange: "#E65100",
//   mediumOrange: "#F57C00",
//   lightOrange: "#FF9800",
//   paleOrange: "#FFF3E0",
//   white: "#FFFFFF",
//   darkText: "#1a1a1a",
//   subText: "#4a4a4a",
// };

// export default function Contact() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     message: "",
//   });
  
//   const [openSnackbar, setOpenSnackbar] = useState(false);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Handle form submission logic here (e.g., API call)
//     console.log("Form Submitted:", formData);
//     setOpenSnackbar(true);
//     setFormData({ name: "", email: "", phone: "", message: "" });
//   };

//   const handleCloseSnackbar = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setOpenSnackbar(false);
//   };

//   return (
//     <Box
//       sx={{
//         py: { xs: 6, md: 10 },
//         bgcolor: "#f9fbf9",
//         minHeight: "80vh",
//       }}
//       id="contact"
//     >
//       <Container maxWidth="lg">
//         {/* Section Header */}
//         <Box sx={{ textAlign: "center", mb: 5 }}>
//           <Chip
//             icon={<SendIcon sx={{ fontSize: 18 }} />}
//             label="GET IN TOUCH"
//             sx={{
//               bgcolor: colors.paleGreen,
//               color: colors.darkGreen,
//               fontWeight: 700,
//               fontSize: "0.8rem",
//               py: 2.5,
//               px: 1,
//               mb: 2,
//               "& .MuiChip-icon": { color: colors.darkGreen },
//             }}
//           />
//           <Typography
//             variant="h4"
//             sx={{
//               fontWeight: 800,
//               color: colors.darkGreen,
//               fontSize: { xs: "1.8rem", md: "2.5rem" },
//               mb: 1.5,
//             }}
//           >
//             Contact & Enquiry
//           </Typography>
//           <Typography
//             variant="body1"
//             sx={{
//               color: colors.subText,
//               maxWidth: 700,
//               mx: "auto",
//               lineHeight: 1.7,
//             }}
//           >
//             Reach out to the Department of Agriculture for queries regarding
//             sapling distribution, schemes, and agroforestry support.
//           </Typography>
//         </Box>

//         <Grid container spacing={4} alignItems="start">
//           {/* Left Column: Contact Information */}
//           <Grid size={{ xs: 12, md: 5 }}>
//             <Card
//               elevation={0}
//               sx={{
//                 borderRadius: 4,
//                 height: "100%",
//                 border: "1px solid",
//                 borderColor: alpha(colors.darkGreen, 0.1),
//                 borderTop: `6px solid ${colors.mediumOrange}`,
//                 p: { xs: 2, md: 0 }, // Padding handled by CardContent
//               }}
//             >
//               <CardContent sx={{ p: { xs: 3, md: 4 } }}>
//                 <Typography
//                   variant="h5"
//                   sx={{ fontWeight: 700, color: colors.darkGreen, mb: 3 }}
//                 >
//                   Contact Information
//                 </Typography>

//                 {/* Address */}
//                 <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, mb: 3 }}>
//                   <Box
//                     sx={{
//                       width: 40,
//                       height: 40,
//                       bgcolor: colors.paleOrange,
//                       color: colors.mediumOrange,
//                       borderRadius: "50%",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       flexShrink: 0,
//                     }}
//                   >
//                     <BusinessIcon />
//                   </Box>
//                   <Box>
//                     <Typography
//                       variant="body2"
//                       sx={{ color: colors.subText, fontWeight: 600, fontSize: "0.9rem" }}
//                     >
//                       Department Address
//                     </Typography>
//                     <Typography
//                       variant="body1"
//                       sx={{ color: colors.darkText, fontWeight: 500 }}
//                     >
//                       Department of Agriculture, <br /> Chepauk, Chennai-05
//                     </Typography>
//                   </Box>
//                 </Box>

//                 {/* Phone */}
//                 <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, mb: 3 }}>
//                   <Box
//                     sx={{
//                       width: 40,
//                       height: 40,
//                       bgcolor: colors.paleOrange,
//                       color: colors.mediumOrange,
//                       borderRadius: "50%",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       flexShrink: 0,
//                     }}
//                   >
//                     <PhoneIcon />
//                   </Box>
//                   <Box>
//                     <Typography
//                       variant="body2"
//                       sx={{ color: colors.subText, fontWeight: 600, fontSize: "0.9rem" }}
//                     >
//                       Phone Number
//                     </Typography>
//                     <Typography
//                       variant="body1"
//                       sx={{ color: colors.darkText, fontWeight: 500 }}
//                     >
//                       (044) 28583323
//                     </Typography>
//                   </Box>
//                 </Box>

//                 {/* Email */}
//                 <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, mb: 4 }}>
//                   <Box
//                     sx={{
//                       width: 40,
//                       height: 40,
//                       bgcolor: colors.paleOrange,
//                       color: colors.mediumOrange,
//                       borderRadius: "50%",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       flexShrink: 0,
//                     }}
//                   >
//                     <EmailIcon />
//                   </Box>
//                   <Box>
//                     <Typography
//                       variant="body2"
//                       sx={{ color: colors.subText, fontWeight: 600, fontSize: "0.9rem" }}
//                     >
//                       Email Address
//                     </Typography>
//                     <Typography
//                       variant="body1"
//                       sx={{ color: colors.darkText, fontWeight: 500 }}
//                     >
//                       coa.fcms@gmail.com
//                     </Typography>
//                   </Box>
//                 </Box>

//                 {/* Office Hours Info Box */}
//                 <Box
//                   sx={{
//                     mt: 4,
//                     bgcolor: colors.paleOrange,
//                     p: 2,
//                     borderRadius: 2,
//                     borderLeft: `4px solid ${colors.mediumOrange}`,
//                   }}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
//                     <AccessTimeIcon sx={{ fontSize: 18, color: "#5d4037" }} />
//                     <Typography
//                       variant="subtitle2"
//                       sx={{ color: "#5d4037", fontWeight: 700 }}
//                     >
//                       Office Hours
//                     </Typography>
//                   </Box>
//                   <Typography variant="body2" sx={{ color: "#5d4037" }}>
//                     Monday to Friday: 10:00 AM - 5:00 PM
//                   </Typography>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Grid>

//           {/* Right Column: Contact Form */}
//           <Grid size={{ xs: 12, md: 7 }}>
//             <Card
//               elevation={3}
//               sx={{
//                 borderRadius: 4,
//                 border: "1px solid",
//                 borderColor: alpha(colors.darkGreen, 0.05),
//               }}
//             >
//               <CardContent sx={{ p: { xs: 3, md: 4 } }}>
//                 <Typography
//                   variant="h5"
//                   sx={{ fontWeight: 700, color: colors.darkGreen, mb: 3 }}
//                 >
//                   Send us a Message
//                 </Typography>
//                 <form onSubmit={handleSubmit}>
//                   <Grid container spacing={2}>
//                     <Grid size={{ xs: 12, sm: 6 }}>
//                       <TextField
//                         fullWidth
//                         label="Full Name"
//                         name="name"
//                         value={formData.name}
//                         onChange={handleChange}
//                         required
//                         variant="outlined"
//                         sx={{
//                           bgcolor: "#fafafa",
//                           "& .MuiOutlinedInput-root": {
//                             "&.Mui-focused fieldset": {
//                               borderColor: colors.mediumGreen,
//                             },
//                           },
//                         }}
//                       />
//                     </Grid>
//                     <Grid size={{ xs: 12, sm: 6 }}>
//                       <TextField
//                         fullWidth
//                         label="Phone Number"
//                         name="phone"
//                         value={formData.phone}
//                         onChange={handleChange}
//                         required
//                         variant="outlined"
//                         type="tel"
//                         InputProps={{
//                             startAdornment: (
//                               <InputAdornment position="start">
//                                 <PhoneIcon fontSize="small" sx={{color: colors.subText}} />
//                               </InputAdornment>
//                             ),
//                           }}
//                         sx={{
//                           bgcolor: "#fafafa",
//                           "& .MuiOutlinedInput-root": {
//                             "&.Mui-focused fieldset": {
//                               borderColor: colors.mediumGreen,
//                             },
//                           },
//                         }}
//                       />
//                     </Grid>
//                     <Grid size={12}>
//                       <TextField
//                         fullWidth
//                         label="Email Address"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleChange}
//                         required
//                         variant="outlined"
//                         type="email"
//                         InputProps={{
//                             startAdornment: (
//                               <InputAdornment position="start">
//                                 <EmailIcon fontSize="small" sx={{color: colors.subText}} />
//                               </InputAdornment>
//                             ),
//                           }}
//                         sx={{
//                           bgcolor: "#fafafa",
//                           "& .MuiOutlinedInput-root": {
//                             "&.Mui-focused fieldset": {
//                               borderColor: colors.mediumGreen,
//                             },
//                           },
//                         }}
//                       />
//                     </Grid>
//                     <Grid size={12}>
//                       <TextField
//                         fullWidth
//                         label="Message"
//                         name="message"
//                         value={formData.message}
//                         onChange={handleChange}
//                         required
//                         variant="outlined"
//                         multiline
//                         rows={4}
//                         placeholder="How can we help you?"
//                         sx={{
//                           bgcolor: "#fafafa",
//                           "& .MuiOutlinedInput-root": {
//                             "&.Mui-focused fieldset": {
//                               borderColor: colors.mediumGreen,
//                             },
//                           },
//                         }}
//                       />
//                     </Grid>
//                     <Grid size={12}>
//                       <Button
//                         type="submit"
//                         variant="contained"
//                         fullWidth
//                         size="large"
//                         endIcon={<SendIcon />}
//                         sx={{
//                           bgcolor: colors.darkGreen,
//                           py: 1.5,
//                           fontWeight: 700,
//                           fontSize: "1rem",
//                           mt: 1,
//                           "&:hover": {
//                             bgcolor: colors.mediumGreen,
//                           },
//                         }}
//                       >
//                         Send Message
//                       </Button>
//                     </Grid>
//                   </Grid>
//                 </form>
//               </CardContent>
//             </Card>
//           </Grid>
//         </Grid>
//       </Container>

//       {/* Success Snackbar */}
//       <Snackbar
//         open={openSnackbar}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity="success"
//           sx={{ width: "100%" }}
//           variant="filled"
//         >
//           Message sent successfully! We will contact you soon.
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Chip,
  TextField,
  Button,
  InputAdornment,
  Snackbar,
  Alert,
  alpha,
} from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SendIcon from "@mui/icons-material/Send";
import "../../i8n";
import { useTranslation } from "react-i18next";
import PostApi from "../../Services/api/ApiCall";
import API_URLS from "../../Services/api/action";
import { useUser } from '../../Context/UserContext';
import { toast } from "react-toastify";

const colors = {
  darkGreen: "#1B5E20",
  mediumGreen: "#2E7D32",
  lightGreen: "#4CAF50",
  paleGreen: "#E8F5E9",
  darkOrange: "#E65100",
  mediumOrange: "#F57C00",
  lightOrange: "#FF9800",
  paleOrange: "#FFF3E0",
  white: "#FFFFFF",
  darkText: "#1a1a1a",
  subText: "#4a4a4a",
};

export default function Contact() {
    const { token } = useUser();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
    try{
        await PostApi(`${API_URLS.Contact}` , formData);
        setOpenSnackbar(true);
        setFormData({ name: "", email: "", phone: "", message: "" });
        toast.success("Form Submitted Successfully");
    }
    catch(e){
        console.log(e, " error");
        toast.error("Error while Submisison");
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        bgcolor: "#f9fbf9",
        minHeight: "80vh",
      }}
      id="contact"
    >
      <Container maxWidth="lg">
        {/* Section Header */}
        <Box sx={{ textAlign: "center", mb: 5 }}>
          <Chip
            icon={<SendIcon sx={{ fontSize: 18 }} />}
            label={t("contact.chip")}
            sx={{
              bgcolor: colors.paleGreen,
              color: colors.darkGreen,
              fontWeight: 700,
              fontSize: "0.8rem",
              py: 2.5,
              px: 1,
              mb: 2,
              "& .MuiChip-icon": { color: colors.darkGreen },
            }}
          />
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              color: colors.darkGreen,
              fontSize: { xs: "1.8rem", md: "2.5rem" },
              mb: 1.5,
            }}
          >
            {t("contact.title")}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: colors.subText,
              maxWidth: 700,
              mx: "auto",
              lineHeight: 1.7,
            }}
          >
            {t("contact.subtitle")}
          </Typography>
        </Box>

        <Grid container spacing={4} alignItems="start">
          {/* Left Column: Contact Information */}
          <Grid size={{ xs: 12, md: 5 }}>
            <Card
              elevation={0}
              sx={{
                borderRadius: 4,
                height: "100%",
                border: "1px solid",
                borderColor: alpha(colors.darkGreen, 0.1),
                borderTop: `6px solid ${colors.mediumOrange}`,
                p: { xs: 2, md: 0 },
              }}
            >
              <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700, color: colors.darkGreen, mb: 3 }}
                >
                  {t("contact.infoTitle")}
                </Typography>

                {/* Address */}
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, mb: 3 }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      bgcolor: colors.paleOrange,
                      color: colors.mediumOrange,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <BusinessIcon />
                  </Box>
                  <Box>
                    <Typography
                      variant="body2"
                      sx={{ color: colors.subText, fontWeight: 600, fontSize: "0.9rem" }}
                    >
                      {t("contact.addressLabel")}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: colors.darkText, fontWeight: 500 }}
                    >
                      {t("contact.address").split(", ").map((line, i, arr) =>
                        i < arr.length - 1 ? (
                          <React.Fragment key={i}>{line}, <br /></React.Fragment>
                        ) : (
                          <React.Fragment key={i}>{line}</React.Fragment>
                        )
                      )}
                    </Typography>
                  </Box>
                </Box>

                {/* Phone */}
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, mb: 3 }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      bgcolor: colors.paleOrange,
                      color: colors.mediumOrange,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <PhoneIcon />
                  </Box>
                  <Box>
                    <Typography
                      variant="body2"
                      sx={{ color: colors.subText, fontWeight: 600, fontSize: "0.9rem" }}
                    >
                      {t("contact.phoneLabel")}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: colors.darkText, fontWeight: 500 }}
                    >
                      {t("contact.phoneNumber")}
                    </Typography>
                  </Box>
                </Box>

                {/* Email */}
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, mb: 4 }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      bgcolor: colors.paleOrange,
                      color: colors.mediumOrange,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <EmailIcon />
                  </Box>
                  <Box>
                    <Typography
                      variant="body2"
                      sx={{ color: colors.subText, fontWeight: 600, fontSize: "0.9rem" }}
                    >
                      {t("contact.emailLabel")}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: colors.darkText, fontWeight: 500 }}
                    >
                      {t("contact.emailAddress")}
                    </Typography>
                  </Box>
                </Box>

                {/* Office Hours Info Box */}
                <Box
                  sx={{
                    mt: 4,
                    bgcolor: colors.paleOrange,
                    p: 2,
                    borderRadius: 2,
                    borderLeft: `4px solid ${colors.mediumOrange}`,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                    <AccessTimeIcon sx={{ fontSize: 18, color: "#5d4037" }} />
                    <Typography
                      variant="subtitle2"
                      sx={{ color: "#5d4037", fontWeight: 700 }}
                    >
                      {t("contact.officeHours")}
                    </Typography>
                  </Box>
                  <Typography variant="body2" sx={{ color: "#5d4037" }}>
                    {t("contact.officeHoursDetail")}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Right Column: Contact Form */}
          <Grid size={{ xs: 12, md: 7 }}>
            <Card
              elevation={3}
              sx={{
                borderRadius: 4,
                border: "1px solid",
                borderColor: alpha(colors.darkGreen, 0.05),
              }}
            >
              <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700, color: colors.darkGreen, mb: 3 }}
                >
                  {t("contact.formTitle")}
                </Typography>
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <TextField
                        fullWidth
                        label={t("contact.fullName")}
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        variant="outlined"
                        sx={{
                          bgcolor: "#fafafa",
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              borderColor: colors.mediumGreen,
                            },
                          },
                        }}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <TextField
                        fullWidth
                        label={t("contact.phone")}
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        variant="outlined"
                        type="tel"
                        InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PhoneIcon fontSize="small" sx={{color: colors.subText}} />
                              </InputAdornment>
                            ),
                          }}
                        sx={{
                          bgcolor: "#fafafa",
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              borderColor: colors.mediumGreen,
                            },
                          },
                        }}
                      />
                    </Grid>
                    <Grid size={12}>
                      <TextField
                        fullWidth
                        label={t("contact.email")}
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        variant="outlined"
                        type="email"
                        InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <EmailIcon fontSize="small" sx={{color: colors.subText}} />
                              </InputAdornment>
                            ),
                          }}
                        sx={{
                          bgcolor: "#fafafa",
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              borderColor: colors.mediumGreen,
                            },
                          },
                        }}
                      />
                    </Grid>
                    <Grid size={12}>
                      <TextField
                        fullWidth
                        label={t("contact.message")}
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        variant="outlined"
                        multiline
                        rows={4}
                        placeholder={t("contact.messagePlaceholder")}
                        sx={{
                          bgcolor: "#fafafa",
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              borderColor: colors.mediumGreen,
                            },
                          },
                        }}
                      />
                    </Grid>
                    <Grid size={12}>
                      <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                        endIcon={<SendIcon />}
                        sx={{
                          bgcolor: colors.darkGreen,
                          py: 1.5,
                          fontWeight: 700,
                          fontSize: "1rem",
                          mt: 1,
                          "&:hover": {
                            bgcolor: colors.mediumGreen,
                          },
                        }}
                      >
                        {t("contact.sendButton")}
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* Success Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
          variant="filled"
        >
          {t("contact.successMessage")}
        </Alert>
      </Snackbar>
    </Box>
  );
}